export var IPaginatedListType;
(function (IPaginatedListType) {
    IPaginatedListType[IPaginatedListType["SELF_COMPUTE"] = -1] = "SELF_COMPUTE";
})(IPaginatedListType || (IPaginatedListType = {}));
export var IPaginatedListTotalCountType;
(function (IPaginatedListTotalCountType) {
    IPaginatedListTotalCountType[IPaginatedListTotalCountType["HAS_MORE"] = -1] = "HAS_MORE";
    IPaginatedListTotalCountType[IPaginatedListTotalCountType["HAS_ENDED"] = -2] = "HAS_ENDED";
})(IPaginatedListTotalCountType || (IPaginatedListTotalCountType = {}));
